export default __webpack_public_path__ + "static/media/2003-AMcover.baf3985a.png";